import React from 'react';
import { useSelector } from 'react-redux';
import { Button, Content, FlexboxGrid, Col, Grid, Row } from 'rsuite';
import PortalHeader from '../../components/layout/PortalHeader';
import { convertNumberToCurrency } from '../../common/utils';
import { selectConfigSettings } from '../../store/slices/config/configSelectors';
import { selectCurrentFlow } from '../../store/slices/flow/flowSelectors';
import { selectPaymentFees, selectPaymentSuccessInfo } from '../../store/slices/payment/paymentSelectors';
import usePlaceNavigate from '../../hooks/usePlaceNavigate';

/**
 * This components is meant to be a generic message to display to the user when a check payment has been completed
 */
const PaymentCompletedCheck = () => {
  const settings = useSelector(selectConfigSettings);
  const currentFlow = useSelector(selectCurrentFlow);
  const paymentFees = useSelector(selectPaymentFees);
  const successInfo = useSelector(selectPaymentSuccessInfo);
  const placeNavigate = usePlaceNavigate();

  const { payTo, mailingAddress, contactEmail, additionalInstructions } = settings?.checkPaymentDetails || {};
  const checkTotal = paymentFees.checkTotal;
  
  if (!settings.checkPaymentDetails) {
    return;
  }

  return (
    <FlexboxGrid justify="space-between">
      <FlexboxGrid.Item colspan={24}>
        <PortalHeader flow={currentFlow} />
      </FlexboxGrid.Item>
      <FlexboxGrid.Item colspan={24}>
        <Content>
          <Grid
            className="mt-24 ml-24 mr-24"
            fluid
          >
            <Row role="presentation" className="mb-16 mt-16">
              <Col
                role="presentation"
                className="content-section"
                xs={24}
              >
                <p id="check-details">Check Details</p>
                <ul aria-labelledby="check-details">
                  <li>
                    Please make the check out to <b>{payTo}</b>.
                  </li>
                  <li>
                    Your unique code is <b>{successInfo?.paymentConfirmation}</b>, please ensure this is written on the front of your check.
                  </li>
                  <li>
                    Please ensure the exact amount of <b>{convertNumberToCurrency(checkTotal)}</b> is written in the check.
                  </li>
                  <li>
                    Please mail all checks to <b>{mailingAddress}</b>.
                  </li>
                  {additionalInstructions?.map((instruction) => `<li>${instruction}</li>`).join('\n')}
                </ul>
                <p>
                  For any questions or issues please contact us at <a href={contactEmail}>{contactEmail}</a>
                </p>
              </Col>
            </Row>
            <Row>
              <Col xs={24}>
                <Button
                  className="btn-primary"
                  onClick={() => placeNavigate('/dashboard')}
                >
                  Return to Dashboard
                </Button>
              </Col>
            </Row>
          </Grid>
        </Content>
      </FlexboxGrid.Item>
    </FlexboxGrid>
  );
};

export default PaymentCompletedCheck;
